import React from 'react';

export function SkeletonBlock({
  width = '100%',
  height = '16px',
  radius = '8px',
  style = {},
}: {
  width?: string;
  height?: string;
  radius?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className="skeleton-block"
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
}

export function SkeletonUpsellCard() {
  return (
    <div className="upsell-card skeleton-card">
      <div className="upsell-card-image-wrap">
        <SkeletonBlock height="100%" radius="0" />
      </div>
      <div className="upsell-card-body" style={{ gap: '8px' }}>
        <SkeletonBlock width="60%" height="10px" radius="4px" />
        <SkeletonBlock width="90%" height="14px" radius="4px" />
        <SkeletonBlock width="75%" height="14px" radius="4px" />
        <SkeletonBlock width="40%" height="16px" radius="4px" style={{ marginTop: '4px' }} />
        <SkeletonBlock width="100%" height="36px" radius="10px" style={{ marginTop: '4px' }} />
      </div>
    </div>
  );
}

export function SkeletonLine({ width = '100%' }: { width?: string }) {
  return <SkeletonBlock width={width} height="12px" radius="4px" />;
}

export function SkeletonCard({ height = '80px' }: { height?: string }) {
  return <SkeletonBlock width="100%" height={height} radius="12px" />;
}
